import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	statusLabel: {
		height: "70px",
	},
	content: {
		padding: theme.spacing(1, 2),
		"&:last-child": {
			paddingBottom: theme.spacing(1),
		},
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(1, 1),
		},
	},
	text: {
		"line-height": "24px",
	},
	overDue: {
		marginTop: 6,
		width: "100vw",
		border: 0,
		borderStyle: "solid",
		borderColor: theme.palette.custom.border.none,
		borderLeftWidth: 4,
	},
	recent: {
		marginTop: 6,
		width: "100vw",
		border: 0,
		borderStyle: "solid",
		borderColor: theme.palette.custom.border.full,
		borderLeftWidth: 4,
	},
	collapsePanelSummary: {
		height: 24,
	},
	expandIcon: {
		color: theme.palette.text.primary,
	},
	caption: {
		padding: "0 0 3px 0",
	},
	value: {
		padding: "0 0 5px 0",
	},
}));
